import React from "react";
import { CameraIcon, ClipboardCheckIcon, EyeIcon, FileTextIcon, Table2Icon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { tools } from "../../data/content";
const iconMap = {
  sheet: FileTextIcon,
  checklist: ClipboardCheckIcon,
  eye: EyeIcon,
  matrix: Table2Icon,
  camera: CameraIcon
};
export function ToolsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-312" data-mp="1nyvaq6awboqr">
      <div className="mx-auto max-w-3xl" data-id="element-313" data-mp="1sq3m37vsdk6k">
        <SectionHeading eyebrow="Ready to print" title={<>And I’ve included these <em className="text-gold-600" data-id="element-315" data-mp="1e28rtn24r7rd">professional tools</em></>} data-id="element-314" data-mp="1sr55q0qvbezw" />

        <ul className="mt-10 divide-y divide-navy-100 rounded-3xl border border-navy-100" data-id="element-316" data-mp="1j0k1nxsfdi9l">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex items-start gap-4 p-5 sm:p-6" data-id="element-317" data-mp="15357ygv52obt">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold-100" data-id="element-318" data-mp="191l1l3lq6uy7">
                  <Icon className="h-6 w-6 text-navy-900" aria-hidden="true" data-id="element-319" data-mp="1ruum4zd9qbew" />
                </span>
                <div data-id="element-320" data-mp="1mvrh3exag56x">
                  <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-321" data-mp="21qnxiff93yv3">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-322" data-mp="1wruujgxlbq96">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 text-center text-lg font-semibold text-navy-900" data-id="element-323" data-mp="192s0f9lrs4xs">Everything is designed to be downloaded, printed and reused.</p>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-324" data-mp="1is3bv2w4plou">
          <CTAButton label="I want access to the complete system" data-id="element-325" data-mp="1isv361ip0x9b" />
        </div>
      </div>
    </section>;
}